export const CREATOR = {
  name: 'Your Name',
  title: 'B.Tech Cloud Computing Student',
  university: 'University Institute of the Coast (IUC)',
  department: 'School of Engineering and Applied Sciences (SEAS)',
  location: 'Limbe, Cameroon',
  email: 'your.email@iuc.edu.cm',
  phone: '+237 6XX XXX XXX',
  projectYear: '2024–2025',
  bio: 'Passionate about cloud-native healthcare solutions and AI-driven cardiac diagnostics. This platform was built as a final-year project to bring affordable, real-time ECG intelligence to hospitals across Africa.',
  skills: ['Cloud Computing', 'React', 'Node.js', 'Machine Learning', 'HL7 FHIR'],
};
